import { createSlice } from '@reduxjs/toolkit';
import * as R from 'ramda';

const initialState = {
  isNavDrawerOpen: false,
  isNavHidden: false, // this is so that we can not show the nav when in create flows in "New Pages"
};

const reducers = {
  setIsNavDrawerOpen: R.assoc('isNavDrawerOpen'),
  setIsNavHidden: R.assoc('isNavHidden'),
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'navigation',
  // eslint-disable-next-line react-hooks/rules-of-hooks
  reducers: R.map(singleReducer => R.flip(R.useWith(singleReducer, [R.prop('payload')])), reducers),
});

export const { setIsNavDrawerOpen, setIsNavHidden } = actions;

export default reducer;
